/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import {
  title,
  mrAuto,
  mlAuto,
  container,
} from "assets/jss/material-kit-pro-react.jsx";
import { pageContent } from "assets/jss/views/apricot.jsx";
import { brand } from "../apricot.jsx";
import { crsCardStyles } from "./courseCardStyle";
import { niceScrollbar } from "assets/jss/views/classroomPage/classroomStyle.jsx";

const icon = {
  width: "2rem",
  height: "2rem",
  margin: "0, 0, 0, 0,5rem",
  display: "inline-block",
};

const styles = (theme) => {
  const infoColor = theme.palette.info.main;
  const secondaryColor = theme.palette.secondary.main;
  const likeColor = theme.palette.warning.main;

  return {
    "@global": niceScrollbar,

    title: {
      ...title,
      color: "#FFFFFF !important",
      textShadow: "1px 1px #B0B0B0",
      zIndex: "5",
      position: "relative",
    },

    like: {
      position: "absolute",
      left: "-1.5rem",
      top: 0,
      color: "red",
    },

    pageContent,
    mrAuto,
    container: {
      ...container,
      position: "relative", // for positioning <Fab> of AllCourses
    },

    brand: { ...brand },
    iconNotes: {
      ...icon,
      color: secondaryColor,
    },

    courseActionBase: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "@media (min-width: 960px)": {
        width: "100%",
      },
    },

    actionButton: {
      margin: "auto 0.5rem",
      cursor: "pointer",
    },

    openButton: {
      "@media (min-width: 600px)": {
        display: "block",
      },
      display: "none",
      margin: "auto 0.5rem",
    },

    srhText: {
      "@media (min-width: 410px)": {
        width: "60%",
      },
      width: "50%",
    },

    ...crsCardStyles,

    likeColor: { color: likeColor },
    dislikeColor: {
      "&:hover": {
        color: likeColor,
      },
      color: "#404040",
    },

    closeButton: {
      backgroundColor: infoColor,
      color: "white",
      position: "absolute",
      right: "5px",
      top: "5px",
      zIndex: 100,
    },

    tabRoot: {
      fontWeight: 600,
      fontSize: "1rem",
    },

    // legalNote: {
    //   cursor: "pointer",
    //   color: theme.palette.secondary.dark,
    //   fontSize: "1rem",
    //   fontFamily: "Open Sans",
    //   fontWeight: "500",
    //   textDecoration: "underline",
    // },

    shareColor: {
      "&, &:focus": {
        backgroundColor: theme.palette.warning.main,
        color: "white",
      },
      "&:hover": { backgroundColor: theme.palette.warning.light },
    },

    btnYT1: {
      "@media (min-width: 1024px)": {
        float: "right",
        marginTop: "-0.25rem",
        display: "block",
      },
      display: "none",
    },

    btnYT2: {
      "@media (max-width: 1023px)": {
        position: "absolute",
        right: "1rem",
        bottom: "1rem",
        display: "block",
        zIndex: 5,
      },
      display: "none",
    },

    //   guideText: {
    //     "@media (min-width: 400px)": {
    //       fontSize: "1.2rem",
    //     },
    //     "@media (min-width: 900px)": {
    //       fontSize: "1.8rem",
    //       display: "inline-block",
    //     },
    //     fontSize: "0.85rem",
    //     fontWeight: 500,
    //     color: infoColor,
    //     display: "block",
    //   },
  };
};

export default styles;
